/** @module csi/table/TablePlaceholderWithPrimaryButton */
define([
	"dojo/_base/declare",
	"csi/html",
	"./TablePlaceholder"
], function(declare,html,TablePlaceholder) {
	
	return declare(TablePlaceholder, {
		/**
		 * @override
		 * Override to use primary button
		 */
		_getPlaceholderCss: function(bCreateButton) {
			return html.CSS_BUTTON_PRIMARY;
		}		
	});
});